<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo"/>
        <div class="columns is-centered is-multiline">
          <div class="column is-12"></div>
          <div class="column is-6">
            <b-notification type="is-primary" has-icon icon-pack="mdi">
              <strong>Confirmando Usuario</strong>
              <br>Aguarde un instante mientras confirmamos su usuario
            </b-notification>
            <progress class="progress is-primary" max="100"></progress>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TituloPrincipal from '@/components/TituloPrincipal.vue'

export default {
  name: 'ConfirmUser',
  data () {
    return {
      titulo: 'Confirmar Contraseña',
      token: this.$route.params.token
    }
  },
  components: {
    TituloPrincipal
  },
  mounted () {
    var componenteVue = this
    function confirmarUsuarioCallback (error, data) {
      componenteVue.isLoading = false
      if (error) {
        componenteVue.$buefy.dialog.alert({
          title: 'Error - ' + error.response.data.status,
          message: error.response.data.message,
          type: 'is-danger',
          hasIcon: true,
          icon: 'close-circle-outline',
          iconPack: 'mdi',
          onConfirm: () => componenteVue.$router.push({ name: 'inicio' })
        })
      } else {
        componenteVue.$buefy.dialog.alert({
          title: 'Usuario Confirmado',
          message: data.message,
          type: 'is-success',
          hasIcon: true,
          icon: 'account-check',
          iconPack: 'mdi',
          onConfirm: () => componenteVue.$router.push({ name: 'inicio' })
        })
      }
    }

    setTimeout(() => {
      // Ejecuta llamdo sobre api
      this.$apiService.confirmarUsuario(this.token, confirmarUsuarioCallback)
    }, 2000)
  }
}
</script>
